module.exports = __webpack_public_path__ + "static/press@2x-f25f9f67f3f3a2632496efebb38294b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/contact-us/press@2x.png
// module id = 2548
// module chunks = 221662759943617